<app-title icon="groups_thin" text="Naročniki">
  <app-toggle-help>
    V zavihku <em>Naročniki</em> nastavite skupine uporabnikov (otroci, učenci, zaposleni, zunanji odjemalci), vključno z dietami. Osnovne nastavitve o uporabnikih uredimo enkrat v tekočem šolskem letu. Podatki vplivajo na količino obrokov, zato naj bodo točni. Za dnevne spremembe uporabite zavihek <em>Odsotnost</em>.
  </app-toggle-help>
</app-title>

<app-main-with-aside>
  <ng-container aside>
    <button class="btn-add-horizontal-large" [class.active]="isNew" [routerLink]="['/groups/add']">
      <span>
        Dodaj nov<br>
        zavod
      </span>
    </button>
    <app-group-list [groups]="groups" [selected]="editGroup" (delete)="delete($event)"></app-group-list>
  </ng-container>

  <ng-container main>
    <app-error></app-error>
    <div class="group-forms">
      <app-group-form *ngIf="isNew" [yearId]="yearId" (changed)="insert($event)" (cancel)="cancelCreate()" (dirty)="setDirty($event)">
        <app-submit-button #submit></app-submit-button>
      </app-group-form>
      <app-group-form *ngIf="editGroup" [yearId]="yearId" [value]="editGroup" (changed)="update(editGroup, $event)" (remove)="delete(editGroup)" (dirty)="setDirty($event)">
        <app-submit-button #submit></app-submit-button>
      </app-group-form>
    </div>
    <div id="aside-marker"></div>
  </ng-container>

</app-main-with-aside>
